import { useEffect, useState } from "react";
import dayjs from "dayjs";

import FormControlLabel from "@mui/material/FormControlLabel";
import { Container } from "@mui/material";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import { MobileDateRangePicker } from "@mui/x-date-pickers-pro/MobileDateRangePicker";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";
import SubTitle from "../../components/SubTitle";
import { useParams } from "react-router-dom";

import { doService } from "../../services/ServiceHelper";
import {
  getTeacherActivityDates,
  deleteActivityDates,
} from "../../services/ActivityService";
import clone from "lodash-es/clone";

const ActivityDates = () => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [showProgress, setShowProgress] = useState(false);
  const [_searchPerformed, setSearchPerformed] = useState(false);
  const [_dateRange, setDateRange] = useState([dayjs(), dayjs()]);

  const [_results, setResults] = useState([]);
  const [_toToggle, setToToggle] = useState(true);
  const { teacherEid } = useParams();

  useEffect(() => {}, []);

  const handleSearch = () => {
    const startDate = _dateRange[0].format("YYYY-MM-DD");
    const endDate = _dateRange[1].format("YYYY-MM-DD");

    setSearchPerformed(true);
    setShowProgress(true);
    doService(
      getTeacherActivityDates(_school, _jwt, startDate, endDate, teacherEid),
      (results) => {
        const activityDates = results.data;

        // add flags for checked
        for (let ad of activityDates) {
          ad.checked = false;
        }
        setResults(results.data);
      },
      null,
      null,
      () => setShowProgress(false)
    );
  };

  const handleBulkDelete = () => {
    const activityDateEids = [];

    for (const item of _results) {
      if (item.checked) {
        activityDateEids.push(item.activityDateEid);
      }
    }

    if (activityDateEids.length === 0) {
      alert("Please select 1 or more activity dates to delete.");
      return;
    }

    setShowProgress(true);
    doService(
      deleteActivityDates(_school, _jwt, activityDateEids),
      (result) => {
        window.showSnack("Activity Dates Deleted");
        setShowProgress(false);
      }
    );
  };

  const handleToggle = () => {
    // clone list
    const listCloned = clone(_results);
    for (const item of listCloned) {
      item.checked = _toToggle;
    }

    setToToggle(!_toToggle);
    setResults(listCloned);
  };

  const handleChangeDateRange = (value) => {
    setDateRange(value);
  };

  const handleChangeCheck = (ad, event) => {
    const isChecked = event.target.checked;
    // clone list
    const listCloned = clone(_results);
    for (const item of listCloned) {
      if (ad.activityDateEid === item.activityDateEid) {
        // update checkbox
        item.checked = isChecked;
        break;
      }
    }

    setResults(listCloned);
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="My Activity Dates" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <Box sx={{ boxShadow: 1, p: 1, mt: 2 }}>
          <SubTitle text="Search by Date Range" />
          <br />
          <MobileDateRangePicker
            defaultValue={[dayjs(), dayjs()]}
            value={_dateRange}
            onChange={handleChangeDateRange}
          />
          <Button
            sx={{ mt: 1 }}
            variant="contained"
            fullWidth
            onClick={handleSearch}
          >
            Search
          </Button>
        </Box>

        {_searchPerformed && (
          <Box sx={{ boxShadow: 1, p: 1, mt: 2 }}>
            <SubTitle text="Search Results" />

            <Grid container spacing={1} sx={{ pt: 1 }}>
              <Grid sx={{ pt: "0.5em !important", mb: 1 }} item xs={6} md={6}>
                <Button
                  sx={{ mt: 0 }}
                  variant="contained"
                  fullWidth
                  onClick={handleToggle}
                  disabled={_results.length === 0}
                >
                  Toggle All
                </Button>
              </Grid>
              <Grid sx={{ pt: "0.5em !important" }} item xs={6} md={6}>
                <Button
                  fullWidth
                  sx={{ mt: 0 }}
                  variant="outlined"
                  onClick={handleBulkDelete}
                  disabled={_results.length === 0}
                >
                  Delete
                </Button>
              </Grid>
            </Grid>
            <TableContainer component={Paper} sx={{ mt: 0, mb: 1 }}>
              <Table aria-label="open passes" size="small">
                <TableBody>
                  {_results.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={10}>
                        -- NO RESULTS RETURNED --
                      </TableCell>
                    </TableRow>
                  )}
                  {_results.map((ad) => (
                    <TableRow key={ad.activityDateEid}>
                      <TableCell>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={(event) => handleChangeCheck(ad, event)}
                              checked={ad.checked}
                            />
                          }
                          label={
                            dayjs(ad.date).format("MM/DD") +
                            ", Per: " +
                            ad.period
                          }
                        />
                      </TableCell>
                      <TableCell>
                        {ad.name}
                        <br />
                        {ad.locationName}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
      </Container>
    </>
  );
};

export default ActivityDates;
